import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/components/ui/breadcrumb';
import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const { pathname } = useLocation();

  const path = pathname.split('/')[1] || 'dashboard';
  const formattedPath = path.replaceAll('-', ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const lastPath = pathname.split('/').pop() || '';

  const excludedPaths = ['edit', 'create', 'new'];

  return excludedPaths.includes(lastPath) ? null : (
    <header className="sticky top-0 z-10 h-14 shrink-0 shadow-md bg-card px-4 m-6 mb-6 rounded-lg">
      <div className="flex h-full items-center gap-2">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="h-4" />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbPage className="text-base font-medium">{formattedPath}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </header>
  );
};

export default Header;
